// Follow-Up Subject Helper (frontend mirror of functions/helpers/followUpSubjectHelper.js)
//
// A follow-up template can opt in via `subjectMode: 'reply_to_previous'`.
// When active, subject resolution should:
//   1. Read `contact.lead_last_email?.subject`.
//   2. Strip repeated reply prefixes ("Re:", "AW:"…) so a 3rd follow-up
//      doesn't end up as "Re: AW: Re: …".
//   3. Prepend the configured prefix — "auto" uses "AW" for German templates
//      and "Re" otherwise.

const REPLY_PREFIX_TOKENS = [
  'RE', 'AW', 'WG', 'FW', 'FWD', 'ANTW', 'SV', 'VS', 'TR', 'RV', 'RIS', 'RIF', 'ENC', 'ODP', 'YNT',
];
const REPLY_PREFIX_RE = new RegExp(
  `^\\s*(?:(?:${REPLY_PREFIX_TOKENS.join('|')})\\s*(?:\\[\\d+\\])?\\s*:\\s*)+`,
  'i'
);

export function stripReplyPrefixes(subject) {
  if (!subject || typeof subject !== 'string') return '';
  let out = subject;
  let prev;
  do {
    prev = out;
    out = out.replace(REPLY_PREFIX_RE, '');
  } while (out !== prev);
  return out.trim();
}

function resolvePrefixToken({ replyPrefix, replyPrefixCustom } = {}) {
  if (replyPrefix === 'custom') {
    const custom = (replyPrefixCustom || '').trim().replace(/:+\s*$/, '');
    if (custom) return custom;
  }
  if (replyPrefix === 'RE') return 'Re';
  // Default (incl. legacy "auto") → AW
  return 'AW';
}

export function buildReplySubject(previousSubject, opts = {}) {
  const core = stripReplyPrefixes(previousSubject);
  if (!core) return null;
  const prefix = resolvePrefixToken(opts);
  return `${prefix}: ${core}`;
}

// Returns the reply subject if the template opts in AND the contact has a
// previous subject. Otherwise returns null so the caller falls back.
export function resolveFollowUpSubject(topic, contact) {
  if (!topic || topic.subjectMode !== 'reply_to_previous') return null;
  const prev = contact && contact.lead_last_email && contact.lead_last_email.subject;
  if (!prev) return null;
  return buildReplySubject(prev, {
    replyPrefix: topic.replyPrefix || 'AW',
    replyPrefixCustom: topic.replyPrefixCustom || '',
  });
}

export const SUBJECT_REPLY_LINE_ID = 'reply_previous';
